import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '../components/feature/ProtectedRoute';

const WelcomePage = lazy(() => import('../pages/welcome/page'));
const ListPage = lazy(() => import('../pages/list/page'));
const DetailPage = lazy(() => import('../pages/detail/page'));
const CollectionPage = lazy(() => import('../pages/collection/page'));
const ProfilePage = lazy(() => import('../pages/profile/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <WelcomePage />
  },
  {
    path: '/lista',
    element: <ProtectedRoute><ListPage /></ProtectedRoute>
  },
  {
    path: '/detalhes/:id',
    element: <ProtectedRoute><DetailPage /></ProtectedRoute>
  },
  {
    path: '/colecao',
    element: <ProtectedRoute><CollectionPage /></ProtectedRoute>
  },
  {
    path: '/perfil',
    element: <ProtectedRoute><ProfilePage /></ProtectedRoute>
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
